import React from 'react';
import SimpleHero from '../../components/SimpleHero/SimpleHero';
import FeatureList from '../../components/Minimal/FeatureList';
import fileImg from "../../assets/images/CD-Account.png";

const CDsTable = () => {
  return (
    <div>
      <SimpleHero
        title="Lock in your rate and earn more"
        subtitle="Pick a term that fits. Simple, secure savings with guaranteed returns."
        primaryLabel="See current rates"
        primaryHref="/contact"
        variant="sofi"
        imageSrc={fileImg}
        imageAlt="CDs preview"
        imageOn="right"
        tiltImage
        badges={["Fixed rate","Flexible terms","FDIC insured"]}
      />
      <FeatureList
        items={[
          { title: 'Flexible terms', desc: 'Choose from short to longer durations.' },
          { title: 'Guaranteed returns', desc: 'Fixed rate through the full term.' },
          { title: 'FDIC insured', desc: 'Coverage up to $250,000.' },
        ]}
      />
      <section className="section text-center">
        <div className="gn-container">
          <a className="btn btn-gn-primary" href="/contact">Ask about rates</a>
        </div>
      </section>
    </div>
  );
};

export default CDsTable;
